import { render, staticRenderFns } from "./delimiterSelect.vue?vue&type=template&id=64ffbeed&scoped=true"
import script from "./delimiterSelect.vue?vue&type=script&lang=js"
export * from "./delimiterSelect.vue?vue&type=script&lang=js"
import style0 from "./delimiterSelect.vue?vue&type=style&index=0&id=64ffbeed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ffbeed",
  null
  
)

export default component.exports